import React from 'react';

const Button = ({ children, onClick, href, variant = 'primary', fullWidth = false, className = '' }) => {
  const baseStyles = 'font-medium py-3 px-8 rounded-lg transition-all duration-300 ease-in-out shadow-sm hover:shadow-md active:transform active:scale-95 inline-flex items-center justify-center text-center';
  
  const variantStyles = {
    primary: 'bg-dc-orange hover:bg-dc-orange-hover text-white',
    secondary: 'bg-white hover:bg-dc-bg text-dc-teal-deep border-2 border-dc-teal-deep',
    ghost: 'bg-transparent hover:bg-dc-teal-deep/5 text-dc-teal-deep'
  };

  const Tag = href ? 'a' : 'button';
  const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : { onClick };

  return (
    <Tag
      {...props}
      className={`
        ${baseStyles}
        ${variantStyles[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {children}
    </Tag>
  );
};

export default Button;